import { PaymentTypesManager } from '@/components/shared/PaymentTypesManager';

export default function PaymentTypes() {
  return <PaymentTypesManager showHeader={false} />;
}
